document.addEventListener("DOMContentLoaded", function() {
    let $video_container = document.getElementsByClassName('js-fullwidth-video');
    
    if ($video_container.length) {
        let $controls = document.getElementsByClassName('js-video-controls');
        
        if ($controls.length) {
            for (let i = 0, videos = $video_container.length; i < videos; i++) {
                $controls[i].onclick = function changeContent(event) {
                    let $video_wrapper = event.target.parentNode.parentNode.nextElementSibling;
                    let $video_overlay = $video_wrapper.previousElementSibling;
                    let $video = $video_wrapper.firstChild;
                    let src = $video.src;

                    const parameters = ['autoplay=', 'mute=', 'muted=', 'controls='];
                    let contains_parameters = parameters.some(parameter => src.includes(parameter));

                    let play_parameter = contains_parameters ? '&autoplay=1' : 'autoplay=1';

                    $video.src = $video.src + play_parameter;
                    $video_wrapper.classList.add('playing');
                    $video_overlay.classList.add('playing');
                }
            }
        }
    }
});